module.exports = __webpack_public_path__ + "img/testimonial-ipst.793eaadc.png";